"use client";

import { useState } from "react";
import OKGoalOddEvenOdds from "@/components/OKGoalOddEvenOdds";
import OKTotalCornersOdds from "@/components/OKTotalCornersOdds";
import OkCorrectScoresOdds from "@/components/OKCorrectScoresOdds";
import "./index.css";

const TAB_IDS = {
  FULL: "FULL",
  HALF: "HALF",
};

const hasData = (array) => Array.isArray(array) && array.length > 0;

export default function OkOtherBetsDropdown({
  goalOddEvenOdds,
  correctScoresOdds,
  totalCornersOdds,
  correctScoresHalfOdds,
  totalCornersHalfOdds,
  homeTeamName,
  awayTeamName,
}) {
  const [activeTab, setActiveTab] = useState(TAB_IDS.FULL);

  const CardWrapper = ({ title, firstHalfLabel, children }) => (
    <div className="kbv-v27-odt-card mb-3 rounded-xl border border-[var(--theme-border)] bg-[var(--kbv-card-bg)] overflow-hidden">
      <div className="kbv-v27-odt-card-title flex items-center h-[58px] px-4 border-b border-[var(--theme-border)] text-sm font-semibold text-[var(--theme-text)]">
        <span className="flex items-center gap-2">
          {firstHalfLabel && (
            <span className="rounded bg-[var(--theme-primary)] px-2 py-0.5 text-xs font-semibold text-[var(--theme-on-primary)]">
              {firstHalfLabel}
            </span>
          )}
          <span>{title}</span>
        </span>
      </div>
      <div className="kbv-v27-odt-card-body pt-2.5 pr-2 pb-0 pl-[12.5px] md:px-7.5 md:pt-6 md:pb-0 rounded-b-xl mt-2">
        {children}
      </div>
    </div>
  );

  const renderFullTab = () => (
    <div className="space-y-3">
      {hasData(correctScoresOdds) && (
        <CardWrapper title="Tỷ Số Chính Xác">
          <OkCorrectScoresOdds
            correctScoresOdds={correctScoresOdds}
            homeTeamName={homeTeamName}
            awayTeamName={awayTeamName}
          />
        </CardWrapper>
      )}

      {hasData(goalOddEvenOdds) && (
        <CardWrapper title="Lẻ/Chẵn">
          <OKGoalOddEvenOdds goalOddEvenOdds={goalOddEvenOdds} />
        </CardWrapper>
      )}

      {hasData(totalCornersOdds) && (
        <CardWrapper title="Tổng Bàn Thắng">
          <OKTotalCornersOdds totalCornersOdds={totalCornersOdds} />
        </CardWrapper>
      )}
    </div>
  );

  const renderHalfTab = () => (
    <div className="space-y-3">
      {hasData(correctScoresHalfOdds) && (
        <CardWrapper title="Tỷ Số Chính Xác" firstHalfLabel="Hiệp Một">
          <OkCorrectScoresOdds
            correctScoresOdds={correctScoresHalfOdds}
            homeTeamName={homeTeamName}
            awayTeamName={awayTeamName}
          />
        </CardWrapper>
      )}

      {hasData(totalCornersHalfOdds) && (
        <CardWrapper title="Tổng Bàn Thắng" firstHalfLabel="Hiệp Một">
          <OKTotalCornersOdds totalCornersOdds={totalCornersHalfOdds} />
        </CardWrapper>
      )}
    </div>
  );

  return (
    <div className="kbv-v27-odt w-full mx-auto mt-3">
      <div className="mb-3 flex gap-2">
        <button
          type="button"
          onClick={() => setActiveTab(TAB_IDS.FULL)}
          className={`kbv-v27-odt-tab min-w-[96px] rounded-full px-4 py-1.5 text-sm font-semibold ${
            activeTab === TAB_IDS.FULL ? "kbv-v27-odt-tab--active" : ""
          }`}
        >
          Cả trận
        </button>
        <button
          type="button"
          onClick={() => setActiveTab(TAB_IDS.HALF)}
          className={`kbv-v27-odt-tab min-w-[96px] rounded-full px-4 py-1.5 text-sm font-semibold ${
            activeTab === TAB_IDS.HALF ? "kbv-v27-odt-tab--active" : ""
          }`}
        >
          Hiệp một
        </button>
      </div>

      {activeTab === TAB_IDS.FULL ? renderFullTab() : renderHalfTab()}
    </div>
  );
}
